/**
 * Sidebar Menu Configuration
 * Contains all menu items and role-based menu logic
 */

import {
  ClipboardDocumentListIcon as ClipboardDocumentListOutline,
  CalendarIcon as CalendarOutline,
  FolderOpenIcon as FolderOpenOutline,
  UserIcon as UserOutline,
  BookOpenIcon as BookOpenOutline,
  DocumentTextIcon as DocumentTextOutline,
  AcademicCapIcon as AcademicCapOutline,
} from "@heroicons/react/24/outline";
import {
  ClipboardDocumentListIcon as ClipboardDocumentListSolid,
  CalendarIcon as CalendarSolid,
  FolderOpenIcon as FolderOpenSolid,
  UserIcon as UserSolid,
  BookOpenIcon as BookOpenSolid,
  DocumentTextIcon as DocumentTextSolid,
  AcademicCapIcon as AcademicCapSolid,
} from "@heroicons/react/24/solid";

export const K_PAGE_WITH_SIDEBAR = [
  "dashboard",
  "profile",
  "myprograms",
  "packagelist",
  "module",
  "modules",
  "myinvoices",
  "invoices",
  "list_vouchers",
  "myvoucher",
  "composite-calculator",
  "programlist",
  "mentor-catalog",
  "grouplist",
  "grouplist-v2",
  "produk",
  "schedule",
  "media",
];

/**
 * Get menu items based on user role
 * @param {Object} user - User object from store
 * @returns {Array} Array of menu items with groups
 */
export const getMenuItems = (user = {}) => {
  const isAdmin = user.isAdmin;
  const isMentor =
    user.isMentor ||
    user.isSuperMentor ||
    user.isReviewer ||
    user.isUkaiTreasurer;

  // Grup 1: Daftar Ujian, Jadwal, Media File
  const group1 = [
    {
      path: "/dashboard",
      label: "Daftar Ujian",
      iconOutline: ClipboardDocumentListOutline,
      iconSolid: ClipboardDocumentListSolid,
      exact: true,
    },
    {
      path: "/dashboard/schedule",
      label: "Jadwal",
      iconOutline: CalendarOutline,
      iconSolid: CalendarSolid,
    },
    {
      path: "/dashboard/media",
      label: "Media File",
      iconOutline: FolderOpenOutline,
      iconSolid: FolderOpenSolid,
    },
  ];

  // Grup 2: Profil, Program Saya, Tagihan Saya
  const group2 = [
    {
      path: "/profile",
      label: "Profil",
      iconOutline: UserOutline,
      iconSolid: UserSolid,
    },
    {
      path: "/myprograms",
      label: "Program Saya",
      iconOutline: BookOpenOutline,
      iconSolid: BookOpenSolid,
    },
    {
      path: "/myinvoices",
      label: "Tagihan Saya",
      iconOutline: DocumentTextOutline,
      iconSolid: DocumentTextSolid,
    },
  ];

  const menuGroups = [
    {
      items: group1,
    },
    {
      items: group2,
    },
  ];

  // Menu untuk mentor/admin
  if (isMentor || isAdmin) {
    menuGroups.push({
      items: [
        {
          path: "/mentor",
          label: "Mentor",
          iconOutline: AcademicCapOutline,
          iconSolid: AcademicCapSolid,
          hasSubmenu: true,
          submenu: [
            ...(isAdmin || user.isSuperMentor
              ? [
                {
                  path: "/programlist",
                  label: "Daftar Program",
                },
                {
                  path: "/mentor-catalog",
                  label: "Daftar Mentor",
                },
              ]
              : []),
            ...(isAdmin || user.isSuperMentor || user.isReviewer
              ? [
                {
                  path: "/packagelist",
                  label: "Daftar Paket Soal",
                },
              ]
              : []),
            ...(isAdmin || user.isMentor
              ? [
                {
                  path: "/grouplist",
                  label: "Daftar Group",
                },
                {
                  path: "/grouplist-v2",
                  label: "Daftar Group V2",
                },
              ]
              : []),
          ],
        },
      ],
    });
  }

  return menuGroups;
};
